import { render } from "./PriceList.vue?vue&type=template&id=652b914f"
import script from "./PriceList.vue?vue&type=script&lang=js"
export * from "./PriceList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__